import { render, staticRenderFns } from "./DevUserRow.vue?vue&type=template&id=31437669"
import script from "./DevUserRow.vue?vue&type=script&lang=js"
export * from "./DevUserRow.vue?vue&type=script&lang=js"
import style0 from "./DevUserRow.vue?vue&type=style&index=0&id=31437669&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports